import React from 'react';

import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { accountsByIdStatusSelector, accountsSelector } from './account/account-selectors';
import { loadAccounts } from './account/actions/load-accounts';
import { userSelector } from './reducers/current-user-selectors';
import { lastVisitedOrgIdSelector } from './reducers/display-settings-selectors';

import { AccountsListPage } from './accounts-list/accounts-list-page';
import { orgRoute } from './web-routes';

import { LoadingMessage } from './widgets/loading-message';
import { NotFoundPage } from './widgets/not-found-page';

const mapStateToProps = (state: any) => {
  const user = userSelector(state);
  return {
    user,
    accounts: accountsSelector(state),
    accountsState: accountsByIdStatusSelector(state),
    lastVisitedOrgId: user.username ? lastVisitedOrgIdSelector(state, user.username) : null,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  actions: {
    loadAccounts: () => dispatch(loadAccounts()),
  },
});

type ReduxProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = ReduxProps & DispatchProps & RouteComponentProps;

// IF (06/29/20): This component redirects a user from the root page to the organization dashboard.
// If the user doesn't have a "last visited orgId" display setting set from a previous session, we default to
// their only org or the first of their orgs in the list. Otherwise, we redirect them to the last
// one they visited. If the user is an admin we send them to the admin organization list.
export const HomePageLandingRedirect = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )((props: Props) => {
    const { actions, history, accounts, accountsState, user, lastVisitedOrgId } = props;

    if (user.isAdmin || user.accountGroupId) {
      return <AccountsListPage />;
    }

    actions.loadAccounts();

    if (!accountsState || accountsState.loading) {
      return <LoadingMessage />;
    }

    const [account] = accounts;
    const { Organizations } = account || {};

    if (!Organizations?.length) {
      return (
        <NotFoundPage
          message={"We're sorry. You do not have access to any organizations."}
          showBeacon
          beaconText={{
            subject: 'Reactivate account',
            text: 'Hello, I would like to reactivate my Team Engine account. Thank you.',
          }}
        />
      );
    }
    if (lastVisitedOrgId && Organizations.find((o) => o.org_id === lastVisitedOrgId)) {
      history.replace(orgRoute(lastVisitedOrgId));
    } else {
      history.replace(orgRoute(Organizations[0].org_id));
    }

    return <LoadingMessage />;
  }),
);
